import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFileCardMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M8 12v-.01m.25.01a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM12 12v-.01m.25.01a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM16 12v-.01m.25.01a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M21.25 12a9.25 9.25 0 1 1-18.5 0 9.25 9.25 0 0 1 18.5 0Z"
    />
  </svg>
);
export default SvgFileCardMenu;
